export interface IPrinter {
  id: number;
  position: number;
  name: string;
  appUrl: string;
  env: string;
  communication: string;
  defaultUrl: string;
  ip: string;
  port: string;
  noOfPrints: number;
}

export const defaultPrinter: IPrinter = {
  id: 0,
  env: "windows",
  defaultUrl: "https://print.aleaf.co.uk/Default.aspx?app=epos",
  appUrl: "default",
  communication: "standard",
  ip: "192.168.2.5",
  port: "9100",
  noOfPrints: 0,
  position: 1,
  name: "1",
};
